import api from '../service/service.js'
import Swal from 'sweetalert2'
export default {
  name: 'users',
  data () {
    return {
      dataall: [],
      window: {
        width: 0,
        height: 0
      },
      open: false,
      searched: '',
      listitem: [],
      datas: [],
      page: {
        page: 1,
        rowPerpage: 5
      },
      datalist: []
    }
  },
  computed: {
    pages () {
      return this.page.rowPerpage
        ? Math.ceil(this.listFilter.length / this.page.rowPerpage)
        : 0
    },
    pagesleft () {
      if (this.page.page === 1) {
        return 0
      }
      return (this.page.page - 1) * this.page.rowPerpage
    },
    pagesright () {
      if (this.page.page === this.pages) {
        return this.listFilter.length
      } else {
        return this.page.page * this.page.rowPerpage
      }
    },
    listFilter () {
      var myNewStr = this.searched.substr(-1)
      var str = this.searched.split(' ')
      console.log(this.datalist)
      for (let i = this.datalist.length; i >= str.length; i--) {
        this.datalist.pop()
      }
      console.log(this.datalist)
      if (myNewStr === ' ') {
        this.datalist.push(this.listitem)
        console.log(this.datalist)
      }
      console.log(this.dataall)
      if (str.length > 1) {
        this.datas = this.datalist[str.length - 2].filter(dataalls => {
          if (
            dataalls.ac_id
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            dataalls.username
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            dataalls.fname
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            dataalls.lname
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            dataalls.position
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase())
          ) {
            return (
              dataalls.ac_id
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              dataalls.username
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              dataalls.fname
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              dataalls.lname
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              dataalls.position
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase())
            )
          }
        })
      } else {
        this.datas = this.dataall.filter(dataalls => {
          console.log(this.searched)
          if (
            dataalls.ac_id
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            dataalls.username
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            dataalls.fname
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            dataalls.lname
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase()) ||
            dataalls.position
              .toLowerCase()
              .includes(str[str.length - 1].toLowerCase())
          ) {
            return (
              dataalls.ac_id
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              dataalls.username
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              dataalls.fname
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              dataalls.lname
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase()) ||
              dataalls.position
                .toLowerCase()
                .includes(str[str.length - 1].toLowerCase())
            )
          }
        })
      }
      console.log(this.datas)
      if (myNewStr === ' ') {
        this.datas = this.listitem
        return this.datas
      } else {
        this.listitem = []
        this.listitem = this.datas
      }
      console.log(this.datas)
      return this.datas
    },
    widthsize () {
      if (this.window.width <= 855) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    pagechange (val) {
      this.page.page = val
    },
    pagecgange (val) {
      console.log(this.pages)
      if (val === 1) {
        if (this.page.page < this.pages) {
          this.page.page += 1
        }
      } else {
        if (this.page.page !== 1) {
          this.page.page -= 1
        }
        return 1
      }
    },
    GetGen (val) {
      console.log(val)
      if (val === '1') {
        return 'ชาย'
      } else {
        return 'หญิง'
      }
    },
    Getstatus (val) {
      console.log(val)
      if (val === '1') {
        return 'เปิด'
      } else {
        return 'ปิด'
      }
    },
    edit (index) {
      let ds = this.dataall[index]
      ds.open = !this.dataall[index].open
      this.dataall.splice(index, 1, ds)
    },
    change (val, index) {
      val.lname = val.lname
      this.dataall[index].open = !this.dataall[index].open
      console.log(this.dataall[index].open)
    },
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
    deleteuser (acid, val) {
      let index = this.dataall.indexOf(val)
      if (index > -1) {
        this.dataall.slice(index, 1)
      }
      Swal.fire({
        title: 'ข้อความแสดงการยืนยัน !',
        text: 'ต้องการลบผู้ใช้งานนี้หรือไม่ ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ยกเลิก'
      }).then(result => {
        if (result.value) {
          let payload = acid
          api.deleteuser(
            payload,
            result => {
              if (result.result === true) {
                this.alert_msg(
                  'success',
                  'ข้อความจากระบบ',
                  'ลบข้อมูลเรียบร้อย !'
                )
                this.dataall = []
                this.getUsers()
              } else {
                Swal.fire('ข้อความจากระบบ', result.data, 'warning')
              }
            },
            calback => {
              console.log(calback)
              Swal.fire('ข้อความจากระบบ', calback, 'error')
            }
          )
        }
      })
    },
    getUsers () {
      api.User(
        result => {
          if (result.result === true) {
            this.dataall = result.data
            console.log(this.dataall)
            for (let i in this.dataall) {
              this.dataall[i].open = false
            }
          }
        },
        calback => {
          console.log(calback)
        }
      )
    }
  },
  mounted () {
    this.getUsers()
    //  console.log(this.menu)
  }
}



// WEBPACK FOOTER //
// ./src/js/manageuser.js